/**
 * This is a simple utility to log a message in local dev or staging, but
 * stay silent in production.
 */
export function nonProdLogger(message: string) {
  let inProd = false
  // Handle case where code is run server-side, where window does not exist.
  try {
    inProd = window.location.host.includes("theconversation.com")
  } catch {
    inProd = false
  }

  if (!inProd) {
    console.log(message)
  }
}
